export enum PaginationTypeEnum {
  ACTIVITIES = 'activities',
  TIMESLOTS = 'timeslots',
}
